import React, { useEffect, useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext";
import Carga from "../../../componentes/cargando/Cargando";

const DashBoardAdministrador = () => {
  const navigate = useNavigate();
  const { verificacionToken } = useAuth();
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const verificar = async () => {
      await verificacionToken("ROLE_ADMINISTRADOR");
      setCargando(false);
    };
    verificar();
  }, []);

  if (cargando) return <Carga />;

  return (
      <div className="container-fluid" style={{ paddingTop: "6rem", minHeight: "calc(100vh - 120px)" }}>
        <div className="row">
          {/* Sidebar */}
          <div className="col-12 col-md-3 mb-4">
            <div
                className="btn-group-vertical w-100 shadow p-3 rounded"
                style={{ backgroundColor: "#ff3399", position: "sticky", top: "6rem" }}
            >
              <Link
                  to="/administrador/punto-venta"
                  className="btn btn-outline-light w-100 mb-2"
              >
                Realizar Venta
              </Link>
              <Link
                  to="/administrador/ventas-diarias"
                  className="btn btn-outline-light w-100 mb-2"
              >
                Mis Ventas Mensual
              </Link>
              <button
                  type="button"
                  className="btn btn-outline-light w-100"
                  onClick={() => navigate("/administrador")}
              >
                Volver Principal
              </button>
            </div>
          </div>

          {/* Contenido principal */}
          <div className="col-12 col-md-9">
            <div className="p-4 shadow rounded" style={{ backgroundColor: "#ff80bf", minHeight: "400px" }}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
  );
};

export default DashBoardAdministrador;
